import React from 'react'
import { NavLink } from 'react-router-dom'
import getDecryptData from '../../helper/getDecryptData';

const NavBar = () => {
    const decryptdatajson = getDecryptData();

    return (

        <>

            <div className="menubar-area footer-fixed">
                <div className="toolbar-inner menubar-nav">
                    <NavLink aria-current="page" className="nav-link " to="/">
                        <i className="ri-home-3-fill fw-light fs-3" />
                        <span className="" style={{ fontWeight: 500 }} >Home</span>
                    </NavLink>
                    {decryptdatajson && decryptdatajson.type === 1 ?
                        <NavLink className="nav-link  " to="/all-order">
                            <i className="ri-shopping-bag-2-fill fw-light fs-3" />
                            <span className="" style={{ fontWeight: 500 }} > All</span>
                        </NavLink> :
                        <NavLink className="nav-link  " to="/custom-order">
                            <i className="ri-shopping-bag-2-fill fw-light fs-3" />
                            <span className="" style={{ fontWeight: 500 }} > Custom</span>
                        </NavLink>

                    }


                    {decryptdatajson && decryptdatajson.type === 1 ?
                        <NavLink className="nav-link  " to="/pending-order">
                            <i className="ri-shopping-bag-2-fill fw-light fs-3" />
                            <span className="" style={{ fontWeight: 500 }} > Pending</span>
                        </NavLink> :
                        <NavLink className="nav-link  " to="/wallet">
                            <i className="ri-wallet-fill fw-light fs-3" />
                            <span className="" style={{ fontWeight: 500 }} >Wallet</span>
                        </NavLink>
                    }


                    <NavLink className="nav-link  " to="/account">
                        <i className="ri-user-6-fill fs-3" />
                        <span className="" style={{ fontWeight: 500 }}> Account</span>
                    </NavLink>
                </div>
            </div>

        </>
    )
}

export default NavBar